import { ThemeConstants } from "owa-theme-shared";
import getIsDarkTheme from "owa-fabric-theme/lib/selectors/getIsDarkTheme";
import { getThemeIdForOrganizationPolicy } from "owa-theme-common";

const BASE_THEME = "base";

export default function normalizeThemeId(themeId: string | undefined): string {
    return (themeId || BASE_THEME).toLowerCase();
}

export interface ThemeRequest {
    themeId: string;
    isDarkTheme: boolean;
}

export function normalizeThemeRequest(id: string | undefined, isDarkTheme: boolean | undefined, isUserPersonalizationAllowed: boolean): ThemeRequest {
    let themeId = getThemeIdForOrganizationPolicy(normalizeThemeId(id));
    
    if (!isUserPersonalizationAllowed) {
        isDarkTheme = false;
        themeId =
            themeId === ThemeConstants.CONTRAST_THEME_ID ? themeId : ThemeConstants.BASE_THEME_ID;
    }
    else {
        // Default to the current mode if not specified
        isDarkTheme = typeof isDarkTheme === "boolean" ? isDarkTheme : getIsDarkTheme();
    }
    
    return { themeId, isDarkTheme };
}
